function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(({
  typography
}) => ({
  iconRoot: {
    width: typography.pxToRem(124),
    height: typography.pxToRem(138)
  }
}));

const NoItems = props => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 124 138",
    classes: {
      root: styles.iconRoot
    }
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M23.575 129.936L72.91 137.621 106.417 128.85 64.996 120.794z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#414042",
    strokeWidth: "7",
    d: "M60.061 95.573c4.41 11.528 3.432 23.476-2.932 35.842"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6A6C70",
    strokeWidth: "7",
    d: "M99.296 112.479c-5.556-8.759-8.334-14.224-8.334-16.396"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#414042",
    strokeWidth: "7",
    d: "M74.675 93.34c3.58 11.947 2.603 23.895-2.932 35.842"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCB992",
    d: "M36.757 0L124 3.873 124 97.067 36.757 100.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6A783",
    d: "M0 0L36.757 3.873 36.757 97.067 0 100.94z",
    transform: "rotate(180 18.379 50.47)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#808285",
    strokeWidth: "5",
    d: "M65.044 75.39l21.531-1.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "64.543",
    cy: "55.243",
    fill: "#808285",
    rx: "3.543",
    ry: "4.243"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "83.321",
    cy: "53.243",
    fill: "#808285",
    rx: "3.321",
    ry: "4.243"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#808285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.443 21.883L11.957 21.884 11.957 23.224 0.443 23.222z",
    transform: "translate(4.429 65.204) rotate(1 6.2 22.553)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.329 1.786H2.658V19.650000000000002H1.329z",
    transform: "translate(4.429 65.204) translate(1.771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.993 0L3.986 4.365 0 4.365z",
    transform: "translate(4.429 65.204) translate(1.771)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.329 1.786H2.658V19.650000000000002H1.329z",
    transform: "translate(4.429 65.204) translate(7.086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.993 0L3.986 4.365 0 4.365z",
    transform: "translate(4.429 65.204) translate(7.086)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0 35L0 0 15 15 15 50z",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M30 35L30 0 15 15 15 50z",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.491 35.872L39.509 45.509 39.509 10.495 29.877 0.491 29.491 35.872z",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.498 45.502L59.503 45.32 59.503 10.498 39.599 10.498 39.498 45.503z",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30 35L40 45 40 10 30 0z",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M40 10L60 10 60 45 40.101 45z",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AA02C",
    d: "M0 35l15 15c.374-2.06 2.456-2.867 2.83-4.926.292-1.608-1.122-4.468-.83-6.075 2.982-.54 2.977-2.276 3-4-.892-1.864-1.12-3.98-.575-5.972L20 25c2.58 5.623 10.088 19.029 8-.104.036-2.34-.61-6.484 2.778-6.635 1.923-.124 5.78 2.515 6.205-.626-.846-3.053 2.45-3.618 4.036-5.432.655-1.217-2.865-4.094-4.672-5.866C34.134 4.07 32.328 2.163 30 0c-5.114 5.236-9.659 9.56-14.886 14.91-2.084 4.07-6.475-4.641-8.687-2.136-.36-5.651-3.418-3.226-3.783-2.57C1.834 11.664 10.81 21.543 10 23c-1.667 0-4.294-1.096-5 0-.73 1.133-1.795 5.031 2.45 6.56.383 2.83-3.177.989-3.487 3.238C3.636 36.692 1.3 34.235 0 35z",
    opacity: ".3",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15 51c6.107-8.555 11.107-13.221 15-14 3.893-.779 7.227 2.221 10 9V27L30 0 15 14v37z",
    opacity: ".3",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD5",
    d: "M42.517 10.511c-.413 2.972-1.5 3.86-1.484 5.002-1.01 2.515-2.114 9.495 2.142 7.31-.446 3.793 2.808-1.018 3.394 1.246-8.287 11.35-1.778 10.134.82 10.393C62.784 48.03 54.885 33.33 58.99 20.334c1.09-1.892.93-3.739.8-5.972.116-1.137.308-3.172.236-4.324-2.105.08-10.37.243-13.742.424 2.655 3.343-1.625 7.09-2.401.731l-1.366-.682z",
    opacity: ".5",
    transform: "translate(39 72)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0021B",
    d: "M5 14C2.113 10-.774 9 .189 4 .189 4 1.15 0 5 0s4.811 4 4.811 4C10.774 9 7.887 10 5 14z",
    transform: "translate(39 72) translate(47 23)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M7.406 5.5C7.406 6.88 6.329 8 5 8 3.671 8 2.594 6.88 2.594 5.5S3.671 3 5 3c1.329 0 2.406 1.12 2.406 2.5z",
    transform: "translate(39 72) translate(47 23)"
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#6A6C70",
    strokeWidth: "7",
    d: "M24.054 57c-3.99 17.646 3.346 32.69 22.009 45.132"
  })));
};

export default NoItems;